export default [
  {
    path: '/payments',
    name: 'payment-list',
    props: true,
    component: () => import('@/views/payments/Index.vue'),
    meta: {
      admin: true,
      requireLogin: true,
      pageTitle: 'Liste des Paiements Livreur',
      description: 'Consultez, filtrez et gérez tous les paiements effectués aux livreurs. Accès rapide aux détails, statuts et actions.',
      accessibility: {
        landmark: 'main',
        ariaLabel: 'Liste des paiements livreur',
        help: 'Cette page présente la liste complète des paiements livreur. Utilisez les filtres pour affiner la recherche et accédez aux détails de chaque paiement.',
      },
      breadcrumb: [
        {
          text: 'Paiement',
          to: { name: 'payment-list' },
        },
        {
          text: 'Liste des paiements',
          active: true,
        },
      ],
      roles: ['admin', 'superadmin', 'manager', 'accountant'],
    },
  },
  {
    path: '/payments/create',
    name: 'payment-add',
    props: true,
    component: () => import('@/views/payments/Create.vue'),
    meta: {
      admin: true,
      requireLogin: true,
      pageTitle: 'Ajouter un Paiement Livreur',
      description: 'Enregistrez un nouveau paiement pour un livreur en renseignant les informations nécessaires.',
      accessibility: {
        landmark: 'form',
        ariaLabel: 'Formulaire d’ajout de paiement',
        help: 'Complétez ce formulaire pour enregistrer un paiement livreur. Tous les champs obligatoires sont signalés.',
      },
      breadcrumb: [
        {
          text: 'Paiements',
          to: { name: 'payment-list' },
        },
        {
          text: 'Ajouter paiement',
          active: true,
        },
      ],
      roles: ['admin', 'superadmin', 'manager', 'accountant'],
    },
  },
  {
    path: '/payments/show/:id',
    name: 'payment-show',
    props: true,
    component: () => import('@/views/payments/Show.vue'),
    meta: {
      requireLogin: true,
      description: 'Consultez tous les détails d’un paiement livreur : informations, montants, commandes associées et historique.',
      accessibility: {
        landmark: 'main',
        ariaLabel: 'Détail du paiement livreur',
        help: 'Cette page présente la fiche complète d’un paiement livreur, avec accès à l’historique, aux montants et aux commandes associées.',
      },
      breadcrumb: [
        {
          text: 'Paiements',
          to: { name: 'payment-list' },
        },
        {
          text: 'Détail',
          active: true,
        },
      ],
      roles: ['admin', 'superadmin', 'manager', 'accountant'],
    },
  },
  {
    path: '/payments/kpi/:id',
    name: 'payment-kpi',
    props: true,
    component: () => import('@/views/payments/KPI.vue'),
    meta: {
      requireLogin: true,
      pageTitle: 'Statistiques Paiement Livreur',
      description: 'Visualisez les indicateurs clés de performance (KPI) et statistiques détaillées pour un paiement livreur.',
      accessibility: {
        landmark: 'main',
        ariaLabel: 'Statistiques paiement livreur',
        help: 'Cette page présente les KPI et statistiques détaillées pour le paiement livreur sélectionné.',
      },
      breadcrumb: [
        {
          text: 'Paiements',
          to: { name: 'payment-list' },
        },
        {
          text: 'Statistiques & KPI',
          active: true,
        },
      ],
      roles: ['admin', 'superadmin', 'manager', 'accountant'],
    },
  },
  // {
  //   path: '/payments/edit/:id',
  //   name: 'payment-edit',
  //   props: true,
  //   component: () => import('@/views/payments/Edit.vue'),
  //   meta: {
  //     admin: true,
  //     requireLogin: true,
  //     pageTitle: 'Modifier Paiement',
  //     breadcrumb: [
  //       {
  //         text: 'Paiements',
  //         to: { name: 'payment-list' },
  //       },
  //       {
  //         text: 'Modifier Paiement',
  //         active: true,
  //       },
  //     ],
  //     roles: ['admin', 'superadmin', 'manager'],
  //   },
  // },
]
